import {Action} from '@ngrx/store';
import {
  HoverDevicePayload,
  SelectGroupIdPayload,
  SelectFloorIdPayload,
  AddGroupIdPayload,
  AddFloorIdPayload,
  RemoveGroupIdPayload,
  RemoveFloorIdPayload
} from '../models/device-grid';
import {Condition} from '../../afb-api/enums/condition.enum';

export enum DeviceGridViewActionTypes {
  HoverDevice = '[DeviceGridView] Hover Device',
  HoverDeviceSuccess = '[DeviceGridView] Hover Device Success',
  HoverOut = '[DeviceGridView] Hover Out',
  HoverOutSuccess = '[DeviceGridView] Hover Out Success',
  SelectCondition = '[DeviceGridView] Select Condition',
  AddCondition = '[DeviceGridView] Add Condition',
  RemoveCondition = '[DeviceGridView] Remove Condition',
  DeselectCondition = '[DeviceGridView] Deselect Condition',
  DeselectConditionSuccess = '[DeviceGridView] Deselect Condition Success',
  SelectGroupId = '[DeviceGridView] Select Group Id',
  AddGroupId = '[DeviceGridView] Add Group Id',
  RemoveGroupId = '[DeviceGridView] Remove Group Id',
  DeselectGroupId = '[DeviceGridView] Deselect Group Id',
  DeselectGroupIdSuccess = '[DeviceGridView] Deselect Group Id Success',
  SelectFloorId = '[DeviceGridView] Select Floor Id',
  AddFloorId = '[DeviceGridView] Add Floor id',
  RemoveFloorId = '[DeviceGridView] Remove Floor id',
  DeselectFloorId = '[DeviceGridView] Deselect Floor Id',
  DeselectFloorIdSuccess = '[DeviceGridView] Deselect Floor Id Success'
}

export class HoverDevice implements Action {
  readonly type = DeviceGridViewActionTypes.HoverDevice;

  constructor(public payload: HoverDevicePayload) {
  }
}

export class HoverDeviceSuccess implements Action {
  readonly type = DeviceGridViewActionTypes.HoverDeviceSuccess;

  constructor(public payload: HoverDevicePayload) {
  }
}

export class HoverOut implements Action {
  readonly type = DeviceGridViewActionTypes.HoverOut;
}

export class HoverOutSuccess implements Action {
  readonly type = DeviceGridViewActionTypes.HoverOutSuccess;
}

export class SelectCondition implements Action {
  readonly type = DeviceGridViewActionTypes.SelectCondition;

  constructor(public payload: Condition) {
  }
}

export class AddCondition implements Action {
  readonly type = DeviceGridViewActionTypes.AddCondition;

  constructor(public payload: Condition) {
  }
}

export class RemoveCondition implements Action {
  readonly type = DeviceGridViewActionTypes.RemoveCondition;

  constructor(public payload: Condition) {
  }
}

export class DeselectCondition implements Action {
  readonly type = DeviceGridViewActionTypes.DeselectCondition;
}

export class DeselectConditionSuccess implements Action {
  readonly type = DeviceGridViewActionTypes.DeselectConditionSuccess;
}

export class SelectGroupId implements Action {
  readonly type = DeviceGridViewActionTypes.SelectGroupId;

  constructor(public payload: SelectGroupIdPayload) {
  }
}

export class AddGroupId implements Action {
  readonly type = DeviceGridViewActionTypes.AddGroupId;

  constructor(public payload: AddGroupIdPayload) {
  }
}

export class RemoveGroupId implements Action {
  readonly type = DeviceGridViewActionTypes.RemoveGroupId;

  constructor(public payload: RemoveGroupIdPayload) {
  }
}

export class DeselectGroupId implements Action {
  readonly type = DeviceGridViewActionTypes.DeselectGroupId;
}

export class DeselectGroupIdSuccess implements Action {
  readonly type = DeviceGridViewActionTypes.DeselectGroupIdSuccess;
}

export class SelectFloorId implements Action {
  readonly type = DeviceGridViewActionTypes.SelectFloorId;

  constructor(public payload: SelectFloorIdPayload) {
  }
}

export class AddFloorId implements Action {
  readonly type = DeviceGridViewActionTypes.AddFloorId;

  constructor(public payload: AddFloorIdPayload) {
  }
}

export class RemoveFloorId implements Action {
  readonly type = DeviceGridViewActionTypes.RemoveFloorId;

  constructor(public payload: RemoveFloorIdPayload) {
  }
}

export class DeselectFloorId implements Action {
  readonly type = DeviceGridViewActionTypes.DeselectFloorId;
}

export class DeselectFloorIdSuccess implements Action {
  readonly type = DeviceGridViewActionTypes.DeselectFloorIdSuccess;
}

export type DeviceGridViewActions =
  | HoverDevice
  | HoverDeviceSuccess
  | HoverOut
  | HoverOutSuccess
  | SelectCondition
  | AddCondition
  | RemoveCondition
  | DeselectCondition
  | DeselectConditionSuccess
  | SelectGroupId
  | AddGroupId
  | RemoveGroupId
  | DeselectGroupId
  | DeselectGroupIdSuccess
  | SelectFloorId
  | AddFloorId
  | RemoveFloorId
  | DeselectFloorId
  | DeselectFloorIdSuccess;
